// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"25b13e8c","498":"820dd068","703":"960692f9"}[chunkId] + ".chunk.js";
};